import { html } from "htm/preact/index.js";

/**
 * @typedef {object} ButtonProps
 * @property {import("preact").ComponentChildren} children
 * @property {string[]} classes
 * @property {boolean} disabled
 * @property {string} href?
 * @property {boolean} isLoading
 * @property {Function} onClick
 * @property {string} tagName
 * @property {string} theme
 * @property {string} size
 * @property {string} style
 * @property {string} type
 * @property {string} target
 */

/**
 * @param {ButtonProps} props
 * @returns {import("preact").VNode}
 */
function Button({
    children,
    classes = [],
    disabled,
    href,
    isLoading,
    tagName = "button",
    theme = "primary",
    size,
    style,
    type = "button",
    onClick,
    target,
    ...rest
}) {
    const buttonClasses = ["moxies-base-button", ...classes];

    switch (theme) {
        case "primary":
            buttonClasses.push("moxies-base-button-green");
            break;
        case "copper":
            buttonClasses.push("moxies-base-button-copper");
            break;
        case "white":
            buttonClasses.push("moxies-base-button-white");
            break;
    }

    if (disabled) buttonClasses.push("moxies-base-button-disabled");
    if (style === "outline") buttonClasses.push("moxies-base-button-outline");
    else buttonClasses.push("moxies-base-button-standard");
    if (size === "lg") buttonClasses.push("moxies-base-button-lg");

    const inner = html`
        <span class="moxies-base-button__bg"></span>
        <span class="moxies-base-button__label">
            ${children}
        </span>
        ${isLoading ? html`<mx-spinner></mx-spinner>` : ""}
    `;

    if (tagName === "a") {
        return html`
            <a
                ...${rest}
                target=${target || "_blank"}
                href=${href}
                class="${buttonClasses.join(" ")}"
            >
                ${inner}
            </a>
        `;
    }

    return html`
            <button
            ...${rest}
            class=${buttonClasses.join(" ")}
            disabled=${disabled || isLoading ? "disabled" : ""}
            type=${type}
            onClick=${onClick}
        >
            ${inner}
        </button>
    `;
}

export default Button;
